"use client";

import { ComponentType } from "react";
import cx from "apps/website/utils/misc/cx";

import Icon from "../Icon/Icon";
import { iconSvgMap, IconSvg } from "../Icon/Icon.map";

import {
  StickerColor,
  StickerVariant,
  StickerSize,
  STICKER_COLOR_CLASSES,
  STICKER_SIZE_CLASSES,
  STICKER_MD_SIZE_CLASSES,
} from "./types";

interface IStickerBaseProps {
  size?: StickerSize;
  mdSize?: StickerSize;
}

interface IStickerVariantProps extends IStickerBaseProps {
  variant: StickerVariant;
  icon?: never;
  badgeColor?: never;
  iconColor?: never;
}

interface IStickerIconProps extends IStickerBaseProps {
  variant?: never;
  icon: IconSvg;
  badgeColor?: StickerColor;
  iconColor?: StickerColor;
}

export type IStickerProps = IStickerVariantProps | IStickerIconProps;

export default function Sticker({
  variant,
  icon,
  size = "sm",
  mdSize,
  badgeColor = "lavender",
  iconColor = "black",
}: Readonly<IStickerProps>) {
  const Badge = iconSvgMap.stickerBadge as ComponentType;
  const ComposableIcon = icon ? iconSvgMap[icon] as ComponentType : null;

  return (
    <div data-component={Sticker.name} className={cx(
      "inline-block aspect-square",
      icon && "relative",
      STICKER_SIZE_CLASSES[size],
      mdSize && STICKER_MD_SIZE_CLASSES[mdSize],
    )}>
      { variant
        ? <Icon icon={variant} className="w-full h-full" />
        : (
          <>
            <span
              className={cx(
                "absolute inset-0 [&>svg]:h-full [&>svg]:w-full",
                STICKER_COLOR_CLASSES[badgeColor],
              )}
            >
              <Badge />
            </span>
            <span
              className={cx(
                "absolute inset-0 p-[10%] [&>svg]:h-full [&>svg]:w-full",
                STICKER_COLOR_CLASSES[iconColor],
              )}
            >
              { ComposableIcon && <ComposableIcon /> }
            </span>
          </>
        ) }
    </div>
  );
}
